import type { CSSProperties } from "react";

/**
 * 15/16px, not 11/12px.
 *
 * This strip is the only thing on screen that says WHICH BUTTON to press, and
 * it was set at caption size - legible on the laptop it was designed on and a
 * grey smudge from an armchair. A guest who cannot read the legend does not
 * discover the remote works; they conclude the television does not.
 */

export interface RemoteHintItem {
  key: string;
  label: string;
  bg?: string;
  fg?: string;
  border?: string;
}

interface Props {
  items: RemoteHintItem[];
  style?: CSSProperties;
}

/**
 * Footer remote-hint row - the persistent "◄ ► Move · OK Select · ← Back"
 * chip strip every scheme puts in the footer. Per-scheme override is via
 * the per-item `bg` / `fg` / `border` props.
 */
export function RemoteHint({ items, style }: Props) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 18, ...style }}>
      {items.map((it, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 22,
              height: 22,
              padding: "0 7px",
              borderRadius: 5,
              background: it.bg ?? "rgba(255,255,255,0.10)",
              color: it.fg ?? "currentColor",
              fontSize: 15,
              fontWeight: 600,
              letterSpacing: "0.02em",
              border: it.border ?? "1px solid rgba(255,255,255,0.18)",
              fontFamily: 'ui-monospace, "SF Mono", Menlo, Consolas, monospace',
            }}
          >
            {it.key}
          </span>
          <span style={{ fontSize: 16, opacity: 0.7 }}>{it.label}</span>
        </div>
      ))}
    </div>
  );
}
